import selectTheme from './UUISelect'

// UUIMultiSelect reuses UUISelect theme completely
// The only additions are checkbox styling which comes from UUICheckbox theme
const multiSelectTheme = selectTheme

export default multiSelectTheme
